import React from 'react';
import styles from './HomepageMain.less';
import TextSection from './components/TextSection/TextSection';
import EkomiWidget from './components/ekomi/EkomiWidget';
import PriceTableWidget from './components/PriceTable/PriceTableWidget';
import PriceTrendChartWidget from "./components/PriceTrendChart/PriceTrendChartWidget";
import featureSwitchReader from "../../utils/featureSwitchReader";
import { HOME_PAGE_REDESIGN_PART_TWO } from "../../utils/featureFlags";
import MyPropertyPromotionWidget from "./components/MyPropertyPromotion/MyPropertyPromotion";

export const HomepageMain = () => {
  const isFeatureOn = featureSwitchReader.getInstance().isFeatureOn;
  return (
    <div className={styles.searchMain}>
      <EkomiWidget />
      <TextSection />
      {isFeatureOn(HOME_PAGE_REDESIGN_PART_TWO) ? <PriceTrendChartWidget /> : <></>}
      {isFeatureOn(HOME_PAGE_REDESIGN_PART_TWO) ? <MyPropertyPromotionWidget /> : <></>}
      <PriceTableWidget />
    </div>
  );
};

export default HomepageMain;
